module.exports = __webpack_public_path__ + "static/media/popup.59023bfd.png";